import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlComponent, DynamicFormControlCustomEvent, DynamicFormLayoutService, DynamicFormValidationService } from '@ng-dynamic-forms/core';
import {InputGridFunctionsFiltersModel} from './input-grid-functions-filters.model';
import { COMPONENT_MODE } from '../../workflow-components.models';

@Component({
  selector: 'dynamic-input-grid-functions-filters',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-input-grid-functions-filters.component.html'
})
export class DynamicInputGridFunctionsFiltersComponent extends DynamicFormControlComponent {
  @Input() bindId = true;
  @Input() group: FormGroup;
  @Input() model: InputGridFunctionsFiltersModel;
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();
  COMPONENT_MODE = COMPONENT_MODE; 
  constructor(protected layoutService: DynamicFormLayoutService, protected validationService: DynamicFormValidationService) {
    super(layoutService, validationService);
  }
}
